export default __webpack_public_path__ + "static/media/gallery_01.583069d9.jpg";